var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor run-javascript" },
    [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.runJavaScriptJavaScriptKodu"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "code-editor-wrapper" }, [
          _c("div", { staticClass: "code-editor-header" }, [
            _c("div", { staticClass: "tips" }, [
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("info")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "auto.runJavaScriptBuBlokKullanCNNYazdJavascriptKodunuAlTRR"
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("warning")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "auto.runJavaScriptGVenlikNedenlerindenDolayBazJavascriptZellikleriKSTlanmTR"
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions d-flex gap-5" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "id-finder-btn",
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.openIDFinder },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "15px",
                          "margin-right": "5px",
                        },
                      },
                      [_vm._v("search")]
                    ),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("auto.runJavaScriptIDFinder")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "fullscreen-btn",
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.toggleFullScreen },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "font-size": "15px",
                          "margin-right": "5px",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.isFullScreen
                                ? "fullscreen_exit"
                                : "fullscreen"
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.isFullScreen ? "Çıkış" : "Tam Ekran") +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "ai-assistant-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showPromptWizard },
                  },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        src: "/static/img/copilot.png",
                        width: "15",
                        height: "15",
                      },
                    }),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("auto.runJavaScriptSupsisAsistan")) +
                        "\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "code-editor" }, [
            _c("div", { staticClass: "available-libraries" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptKullanLabilirKTPhaneler"))
                ),
              ]),
              _vm._v(" "),
              _c("code", [_vm._v("moment")]),
              _vm._v(", "),
              _c("code", [_vm._v(_vm._s(_vm.$t("auto.runJavaScriptLodash")))]),
              _vm._v(", "),
              _c("code", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptAxiosSadeceGetVePost"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "available-variables" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptKullanLabilirDeIKenler"))
                ),
              ]),
              _vm._v(" "),
              _c("code", [_vm._v("params")]),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("auto.runJavaScriptNcekiBloklarNDeErleri")) +
                  "\n                        "
              ),
              _c("code", [
                _vm._v(
                  _vm._s(
                    _vm.$t("auto.runJavaScriptTaskReadattributeKeyDefaultvalue")
                  )
                ),
              ]),
              _vm._v(",\n                        "),
              _c("code", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptTaskBindattributeData"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-help" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("auto.runJavaScriptOtomasyonDeIKenleri"))),
              ]),
              _vm._v(" "),
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.runJavaScriptBlockBlockid"))),
              ]),
              _vm._v(", "),
              _c("code", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptEventEventtypeEventname"))
                ),
              ]),
              _vm._v(", "),
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.runJavaScriptSystemDate"))),
              ]),
              _vm._v(",\n                        "),
              _c("code", [
                _vm._v(
                  _vm._s(_vm.$t("auto.runJavaScriptWebhookBodyFieldname"))
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("auto.runJavaScriptEklindeKullanLabilir")) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "monaco-editor-container",
              class: { "fullscreen-editor": _vm.isFullScreen },
              attrs: { id: "monaco-editor-container" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "code-restrictions" }, [
            _c("div", { staticClass: "restriction-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.runJavaScriptKSTlamalar"))),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptProcessExitChildProcessGibiTehlikeliNodeJsZellikleriYasaktR"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptRequireEvalVeFunctionFonksiyonlarKullanLamaz"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptDosyaSistemiFsKriptoVeAILemleriKSTlanmTR"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t("auto.runJavaScriptKodAlMaSResi5SaniyeIleSNRlDR")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptHTTPIstekleriIInZamanAM3Saniyedir"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptSonsuzDNgLerVeServerlarOluTurulamaz"
                    )
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "example-usage" }, [
            _c("div", { staticClass: "example-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.runJavaScriptKodRneI"))),
            ]),
            _vm._v(" "),
            _c("pre", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "auto.runJavaScriptAsyncFunctionMainParamsMomentKTPhanesiniKullanmaRneIConstNowMomentFormatYyyyMmDdHhMmSsLodashKullanMConstUsersNameMesutAge30NameAhmetAge25ConstOldestMaxbyUsersAgeOtomasyonDeIKenleriniKullanmaConstDateTaskReadattributeSystemDateConstContactnameTaskReadattributeContactFullnameSupsisSdkKullanMRneILetResultTryKullanCLarListelemeConstUserlistAwaitSupsisUsersListResultUsercountUserlistLengthKiIBilgisiAlmaVarsaIfParamsContactidConstContactAwaitSupsisContactGetParamsContactidResultContactinfoNameContactFullnameEmailContactEmailModLlerZerindeAlMa1TMModLleriListeleConstModulesAwaitSupsisModuleListResultModulecountModulesLength2ZelBirModLIleAlMaRnekMTerilerModLConstNewcustomerAwaitSupsisModuleCustomersCreateFullnameContactnameRegisterdateNowStatusActiveResultNewcustomeridNewcustomerId3ModLKaydAramaConstCustomerrecordsAwaitSupsisModuleCustomersSearchFiltersFieldStatusOperatorEqValueActiveSortFullname1CursorPage1Perpage10ResultCustomercountCustomerrecordsTotal4ZelAktiviteOluTurmaConstCustomactivityAwaitSupsisActivityCreateMessageOtomasyonTarafNdanZelAktiviteOluTurulduNotificationUsersIdParamsUserid123456789ConfigWebFalseEmailTrueMobileFalseConfigWebTrueEmailTrueMobileFalseActionsActionViewRecordPayloadTitleMTeriDetayTableidCustomersRecordidParamsCustomerid123456ActionOpenWidgetPayloadTitleMTeriWidgetUrlHttpsExampleComCustomerDashboardFullscreenFalseModeUrlHtmlUsersUserid1ResultActivityidCustomactivityIdCatchErrorHataYNetimiResultErrorErrorMessageDNdRLenDeErBloUnKtSOlarakKaydedilirReturnCurrenttimeNowOldestuserOldestNameCalculatedParamsPreviousvalueParamsPreviousvalue20SystemdateDateContactnameContactnameApiresultsResult"
                  )
                ) + "\n"
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("auto.runJavaScriptJavaScriptAsistan"),
            width: 800,
            footer: null,
          },
          on: { cancel: _vm.handleAssistantClose },
          model: {
            value: _vm.showJsAssistant,
            callback: function ($$v) {
              _vm.showJsAssistant = $$v
            },
            expression: "showJsAssistant",
          },
        },
        [
          _c("div", { staticClass: "js-assistant-modal" }, [
            _c("div", { staticClass: "js-assistant-description" }, [
              _c("h4", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.runJavaScriptJavaScriptKodunuYapayZekaIleOluTurun"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t(
                        "auto.runJavaScriptYapmakIstediInizILemiDoAlDildeAKlayNSupsisAsistanSizinIInJavascriptKodunuOluTursun"
                      )
                    ) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "js-capabilities" }, [
                _c(
                  "div",
                  { staticClass: "capabilities-header" },
                  [
                    _c("a-icon", { attrs: { type: "bulb" } }),
                    _vm._v(" "),
                    _c("h5", [
                      _vm._v(
                        _vm._s(_vm.$t("auto.runJavaScriptYapabilecekleriniz"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "capabilities-content" }, [
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("functions"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("auto.runJavaScriptHesaplamalarYapma"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("compare_arrows"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auto.runJavaScriptVeriDNMleri"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("filter_list"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("auto.runJavaScriptVeriFiltreleme"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("http"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("auto.runJavaScriptAPIIstekleriYapma"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("today"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auto.runJavaScriptTarihILemleri"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_list_numbered"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auto.runJavaScriptDiziILemleri"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-container" },
              [
                _c("s2-textarea", {
                  ref: "promptTextarea",
                  attrs: {
                    rows: 4,
                    placeholder:
                      "Örnek: Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle",
                  },
                  model: {
                    value: _vm.jsPrompt,
                    callback: function ($$v) {
                      _vm.jsPrompt = $$v
                    },
                    expression: "jsPrompt",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "example-prompts" }, [
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "calculator" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("auto.runJavaScriptHarcamaHesaplaVeEtiketle")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Müşteri adını ve soyadını alarak tam ad oluştur ve selamlama mesajı hazırla"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "user" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "auto.runJavaScriptMTeriBilgisiyleMesajHazRla"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "API'den hava durumu bilgisi al ve sıcaklığa göre aktivite önerisi yap"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "cloud" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "auto.runJavaScriptAPIIleHavaDurumunaGReNeri"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-container" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.handleAssistantClose } },
                      [_vm._v(_vm._s(_vm.$t("auto.runJavaScriptPtal")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.assistantLoading,
                        },
                        on: { click: _vm.generateJavaScriptCode },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("auto.runJavaScriptKodOluTur")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }